var render = function render(){var _vm=this,_c=_vm._self._c;return _c('relatorio-risco',{attrs:{"objetivo":"reprovacao","titulo":"RELATÓRIO DE RISCO DE REPROVAÇÃO"}})
}
var staticRenderFns = []

export { render, staticRenderFns }